export default "__VITE_ASSET__DFh33NEt__"